/* Manage block types */

import { PhotoType } from '../enums/enums'
import { SeverityType } from '../services/notification.service'

export type UploadDataType = {
  photoType: PhotoType
  title: string
  helper: string
}

/* Upload block types */
export type UploadImageStatusType = 'pending' | 'success' | 'error' | 'idle'

export type UploadImageResultType = {
  status: UploadImageStatusType
  message: string
}

export type ContactType = {
  type: SocNetworkType
  link: string
}

export type UpdateContactsType = {
  lang: 'ru' | 'eng'
  contact: ContactType
}

export type SocNetworkType =
  | 'VK'
  | 'INSTAGRAM'
  | 'YOUTUBE'
  | 'TWITTER'
  | 'FACEBOOK'
  | 'SOUNDCLOUD'
  | 'TWITCH'
  | 'TIKTOK'
  | 'BEATMAKERS.TV'

export interface ISocialContact {
  type: SocNetworkType
  url: string
  urlImg?: string
}

export interface IDomainSocIcon extends ISocialContact {
  icon: string
}

export interface IBeatmakerData {
  contacts: Array<ISocialContact>
  backgroundImageUrl: string
  backgroundLogoImageUrl: string
  footerLogoUrl: string
  logoUrl: string
  logoSlogan: string
  footerText: string
  faviconUrl: string
  ownerData: {
    fullName: string
    adminEmail: string
  }
  emailSecret: string
  defaultBeatsSorting: number
  origin: null
  beatmakerId: number
  beatmakerName: string
  host: string
  language: string
  message: string
  currentUserId: number
  currentUserEmail: string
  colors: string // 2 формата:
  // 1 - старый формат данных: colors: [string]
  // 2 - новый формат данных: colors: {styles: string, theme: string}
}

export type ContactsResultMessageType = {
  message: string
  type: SocNetworkType
  severity: SeverityType
}
